import {Type} from "../../../Transaction/helper";

export function parseTransactionForInstruction(transactionType, transaction) {
    switch (transactionType) {
        case Type.sale_invoice: {
            const preprocessedContactId = (
                transaction.contact_id ? `contact_${transaction.contact_id}` : undefined
            );
            const preprocessedGroupId = (
                transaction.group_id ? `group_${transaction.group_id}` : undefined
            );

            return {
                ...transaction,
                date: undefined,
                billing_party: undefined,
                shipping_party: undefined,
                contact_and_group_id: preprocessedContactId || preprocessedGroupId,
                term_items: transaction.term_items.map(item => ({ ...item, date: undefined })),
            };
        }
        case Type.purchase_bill:
            return {
                ...transaction,
                date: undefined,
                due_date: undefined,
                billing_party: undefined,
            };
        case Type.bank_income:
        case Type.bank_expense:
        case Type.bank_transfer:
        case Type.journal_entry:
            return {
                ...transaction,
                date: undefined,
            };
        default:
            return transaction;
    }
}
